// actions
import { SET_MAP, SET_ZOOM, SET_GEOLOCATION, SET_BOUNDS, SET_PLATFORM } from '../constants/types';

const initialState = {
  map: null,
  zoom: 11,
  geolocation: false,
  bounds: {
    northeast: {
      lat: 37.646341193252645,
      lng: -121.43147393437499,
    },
    southwest: {
      lat: 37.29319992362275,
      lng: -122.42024346562499,
    },
  },
};

const mapReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAP:
      return {
        ...state,
        map: action.map,
      };
    case SET_ZOOM:
      return {
        ...state,
        zoom: action.zoom,
      };
    case SET_GEOLOCATION:
      return {
        ...state,
        geolocation: action.geolocation,
      };
    case SET_BOUNDS:
      return {
        ...state,
        bounds: action.bounds,
      };
    case SET_PLATFORM:
      return {
        ...state,
        platform: 'kiosk',
      };
    default:
      return state;
  }
};

export default mapReducer;
